module.exports = __webpack_public_path__ + "static/media/Assets-05-MNM-hero.6c68aedb.png";